import actions from './actions';

const { ADD_FEATURE_FLAGS, addFeatureFlags } = actions;

export { ADD_FEATURE_FLAGS, addFeatureFlags };

export { featureFlags } from './reducers';

export { getIsMarketingToolsExperimentEnabled } from './selectors';
